import Vue from 'vue'
import VueRouter from 'vue-router'
//官方的元件


const Home = () => import ('@/components/page/HelloWorld');
// const hotIndex = () => import ('@/components/page/hotIndex');
const PreOrder = () => import ('@/components/page/preOrder');
const ProductDetailed = () => import ('@/components/page/productDetailed');
const Cart = () => import ('@/components/page/cart');
const Login = () => import ('@/components/page/login');
const Registered = () => import ('@/components/page/registered');
const Complete = () => import ('@/components/page/complete');
const Member = () => import ('@/components/page/member');
const Datamodification = () => import ('@/components/page/datamodification');
const changePassword = () => import ('@/components/page/changepassword');
const Forgetpassword = () => import ('@/components/page/forgetpassword');
const Forgetpassword_part2 = () => import ('@/components/page/forgetpassword_part2');
const Verify = () => import ('@/components/page/verify');
const New = () => import ('@/components/page/new');
const OrderingInstructions = () => import ('@/components/page/orderingInstructions');
const AboutUs = () => import ('@/components/page/aboutUs');
const ContactUs = () => import ('@/components/page/contactUs');
const ConsumerOrder = () => import ('@/components/page/consumerOrder');

const Dashboard = () => import ('@/components/backEnd/dashboard');
const DealerOrder = () => import ('@/components/backEnd/dealerOrder');

const Product = () => import ('@/components/manager/product');
const Type = () => import ('@/components/manager/type');
const Color = () => import ('@/components/manager/color');
const Size = () => import ('@/components/manager/size');

const Manager = () => import ('@/components/manager/managerDashboard');
const Order = () => import ('@/components/manager/order');
const OrderDetail = () => import ('@/components/manager/orderDetail');
const MoveOrder = () => import ('@/components/manager/moveOrder');
const IpLocation = () => import ('@/components/manager/ipLocation');
const ManagerMember = () => import ('@/components/manager/member');
const LoginMaximumAuthority = () => import ('@/components/manager/loginMaximumAuthority');
const OutputFile = () => import ('@/components/manager/outputFile');
const ShoppingStatistics = () => import ('@/components/manager/shoppingStatistics');
const LimitNum = () => import ('@/components/manager/limitNum');
const SaleFrame = () => import ('@/components/manager/saleFrame');
const CycleCarousel = () => import ('@/components/manager/cycleCarousel');
const Announcement = () => import ('@/components/manager/announcement');
const OrderManager = () => import ('@/components/manager/orderManager');
const GroupLog = () => import ('@/components/manager/groupLog');
const AboutusManager = () => import ('@/components/manager/aboutusManager');
const ContactusManager = () => import ('@/components/manager/contactusManager');
const Pay = () => import ('@/components/manager/pay');
const Transport = () => import ('@/components/manager/transport');

// 進銷存系統
const Suppliers = () => import ('@/components/invoicing/suppliers');//廠商管理
const Client = () => import ('@/components/invoicing/client');//客戶管理
const BasicUnit = () => import ('@/components/invoicing/basicUnit');//基本單位
const AuxiliaryUnit = () => import ('@/components/invoicing/auxiliaryUnit');//輔助單位
const ProductCategory = () => import ('@/components/invoicing/productCategory');//基本欄位
const BasicField = () => import ('@/components/invoicing/basicField');//基本欄位
const Purchase = () => import ('@/components/invoicing/purchase');//採購單
const ArrivalGoods = () => import ('@/components/invoicing/arrivalGoods');//進貨單
const QuitGoods = () => import ('@/components/invoicing/quitGoods');//進退單
const Sales = () => import ('@/components/invoicing/sales');//銷貨單
const SalesReturn = () => import ('@/components/invoicing/salesReturn');//銷退單
const Transfer = () => import ('@/components/invoicing/transfer');//轉倉

//會計系統
const CollectionProcessing = () => import ('@/components/accounting/collectionProcessing');//收款處理
const PaymentProcessing = () => import ('@/components/accounting/paymentProcessing');//付款處理
const Inventory = () => import ('@/components/accounting/inventory');//盤點作業
const CostReport = () => import ('@/components/accounting/costReport');//成本報表
const ProfitStatement = () => import ('@/components/accounting/profitStatement');//利潤報表
const ReceivableStatement = () => import ('@/components/accounting/receivableStatement');//應收對帳單
const PaymentStatement = () => import ('@/components/accounting/paymentStatement');//應付對帳單

// 測試頁面
const Text = () => import ('@/components/text/text');

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes:[
        {
            path:'*',//對應的虛擬路徑
            redirect:'index'//對應的元件
        },
        {
            name:'first1',//元件呈現的名稱
            path:'/index',//對應的虛擬路徑
            component:Home,//對應的元件
        },
        // {
        //     name:'first2',//元件呈現的名稱
        //     path:'/index/:shopId',//對應的虛擬路徑
        //     component:Home,//對應的元件
        // },
        // {
        //   name:'hot1',//元件呈現的名稱
        //   path:'/hotIndex',//對應的虛擬路徑
        //   component:hotIndex,//對應的元件
        // },
        // {
        //   name:'hot2',//元件呈現的名稱
        //   path:'/hotIndex/:shopId',//對應的虛擬路徑
        //   component:hotIndex,//對應的元件
        // },
        {
          name:'preOrder1',//元件呈現的名稱
          path:'/preOrder',//對應的虛擬路徑
          component:PreOrder,//對應的元件
        },
        {
          name:'preOrder2',//元件呈現的名稱
          path:'/preOrder/:shopId',//對應的虛擬路徑
          component:PreOrder,//對應的元件
        },
        {
            name:'cart',//元件呈現的名稱
            path:'/cart',//對應的虛擬路徑
            component:Cart,//對應的元件
        },

        {
            name:'productDetailed',//元件呈現的名稱
            path:'/productDetailed/:productId',//對應的虛擬路徑
            component:ProductDetailed,//對應的元件
        },
        {
            name:'login',//元件呈現的名稱
            path:'/login',//對應的虛擬路徑
            component:Login,//對應的元件
        },
        {
            name:'registered',//元件呈現的名稱
            path:'/registered',//對應的虛擬路徑
            component:Registered,//對應的元件
        },
        {
            name:'完成註冊',
            path:'/complete',
            component:Complete,

        },
        {
            name:'new',
            path:'/new',
            component:New,

        },
        {
            name:'orderingInstructions',
            path:'/orderingInstructions',
            component:OrderingInstructions,

        },
        {
            name:'aboutUs',
            path:'/aboutUs',
            component:AboutUs,

        },
        {
            name:'contactUs',
            path:'/contactUs',
            component:ContactUs,

        },
        {
            name:'member',//元件呈現的名稱
            path:'/member',//對應的虛擬路徑
            component:Member,//對應的元件
            meta: { requiresAuth: true }
        },
        {
            name:'consumerOrder',//元件呈現的名稱
            path:'/consumerOrder',//對應的虛擬路徑
            component:ConsumerOrder,//對應的元件
            meta: { requiresAuth: true }
        },
        {
            name:'datamodification',//元件呈現的名稱
            path:'/datamodification',//對應的虛擬路徑
            component:Datamodification,//對應的元件
        },
        {
            name:'changepassword',//元件呈現的名稱
            path:'/changepassword',//對應的虛擬路徑
            component:changePassword,//對應的元件
        },
        {
            name:'forgetpassword',//元件呈現的名稱
            path:'/forgetpassword',//對應的虛擬路徑
            component:Forgetpassword,//對應的元件
        },
        {
            name:'forgetpassword_part2',//元件呈現的名稱
            path:'/forgetpassword_part2/:email/:verify/',//對應的虛擬路徑
            component:Forgetpassword_part2,//對應的元件
        },
        {
            name:'verify',//元件呈現的名稱
            path:'/verify/:verify/',//對應的虛擬路徑
            component:Verify,//對應的元件
        },
        {
            name:'dashboard',//元件呈現的名稱
            path:'/backEnd',//對應的虛擬路徑
            component:Dashboard,//對應的元件
            children:[
                {
                    name:'dealerOrder',
                    path:'dealerOrder',
                    component:DealerOrder,
                },
              ]
        },
        {
            name:'loginMaximumAuthority',//元件呈現的名稱
            path:'/loginMaximumAuthority',//對應的虛擬路徑
            component:LoginMaximumAuthority,//對應的元件
        },
        {
            name:'text',//元件呈現的名稱
            path:'/text',//對應的虛擬路徑
            component:Text,//對應的元件
        },
        {
            name:'manager',//元件呈現的名稱
            path:'/manager',//對應的虛擬路徑
            component:Manager,//對應的元件
            meta: { requiresAuth: true },
            children:[
                {
                  name:'managerMember',
                  path:'managerMember',
                  component:ManagerMember,
                  meta: { requiresAuth: true }
                },
                {
                    name:'product',
                    path:'product',
                    component:Product,
                    meta: { requiresAuth: true }
                },
                {
                    name:'ipLocation',
                    path:'ipLocation',
                    component:IpLocation,
                    meta: { requiresAuth: true }
                },
                {
                    name:'type',
                    path:'type',
                    component:Type,
                    meta: { requiresAuth: true }
                },
                {
                    name:'color',
                    path:'color',
                    component:Color,
                    meta: { requiresAuth: true }
                },
                {
                    name:'size',
                    path:'size',
                    component:Size,
                    meta: { requiresAuth: true }
                },
                {
                    name:'order',
                    path:'order',
                    component:Order,
                    meta: { requiresAuth: true }
                },
                {
                    name:'orderDetail',
                    path:'orderDetail/:id?',
                    component:OrderDetail,
                    meta: { requiresAuth: true }
                },
                {
                    name:'moveOrder',
                    path:'moveOrder',
                    component:MoveOrder,
                    meta: { requiresAuth: true }
                },
                {
                  name:'groupLog',
                  path:'groupLog',
                  component:GroupLog,
                  meta: { requiresAuth: true }
              },
                {
                    name:'outputFile',
                    path:'outputFile',
                    component:OutputFile,
                    meta: { requiresAuth: true }
                },
                {
                    name:'limitNum',
                    path:'limitNum',
                    component:LimitNum,
                    meta: { requiresAuth: true }
                },
                {
                    name:'saleFrame',
                    path:'saleFrame',
                    component:SaleFrame,
                    meta: { requiresAuth: true }
                },
                {
                    name:'saleFrame',
                    path:'saleFrame/:productId',
                    component:SaleFrame,
                    meta: { requiresAuth: true }
                },
                {
                    name:'shoppingStatistics',
                    path:'shoppingStatistics',
                    component:ShoppingStatistics,
                    meta: { requiresAuth: true }
                },
                {
                    name:'cycleCarousel',
                    path:'cycleCarousel',
                    component:CycleCarousel,
                    meta: { requiresAuth: true }
                },
                {
                    name:'announcement',
                    path:'announcement',
                    component:Announcement,
                    meta: { requiresAuth: true }
                },
                {
                    name:'orderManager',
                    path:'orderManager',
                    component:OrderManager,
                    meta: { requiresAuth: true }
                },
                {
                    name:'aboutusManager',
                    path:'aboutusManager',
                    component:AboutusManager,
                    meta: { requiresAuth: true }
                },
                {
                    name:'contactusManager',
                    path:'contactusManager',
                    component:ContactusManager,
                    meta: { requiresAuth: true }
                },
                {
                    name:'pay',
                    path:'pay',
                    component:Pay,
                    meta: { requiresAuth: true }
                },
                {
                    name:'transport',
                    path:'transport',
                    component:Transport,
                    meta: { requiresAuth: true }
                },
                {
                    name:'basicField',
                    path:'basicField',
                    component:BasicField,
                    meta: { requiresAuth: true }
                },
                {
                    name:'purchase',
                    path:'purchase',
                    component:Purchase,
                    meta: { requiresAuth: true }
                },
                {
                    name:'arrivalGoods',
                    path:'arrivalGoods',
                    component:ArrivalGoods,
                    meta: { requiresAuth: true }
                },
                {
                    name:'quitGoods',
                    path:'quitGoods',
                    component:QuitGoods,
                    meta: { requiresAuth: true }
                },
                {
                  name:'sales',
                  path:'sales',
                  component:Sales,
                  meta: { requiresAuth: true }
                },
                {
                    name:'salesReturn',
                    path:'salesReturn',
                    component:SalesReturn,
                    meta: { requiresAuth: true }
                },
                {
                    name:'transfer',
                    path:'transfer',
                    component:Transfer,
                    meta: { requiresAuth: true }
                },
                {
                    name:'suppliers',
                    path:'suppliers',
                    component:Suppliers,
                    meta: { requiresAuth: true }
                },
                {
                    name:'client',
                    path:'client',
                    component:Client,
                    meta: { requiresAuth: true }
                },
                {
                    name:'basicUnit',
                    path:'basicUnit',
                    component:BasicUnit,
                    meta: { requiresAuth: true }
                },
                {
                    name:'auxiliaryUnit',
                    path:'auxiliaryUnit',
                    component:AuxiliaryUnit,
                    meta: { requiresAuth: true }
                },
                {
                    name:'productCategory',
                    path:'productCategory',
                    component:ProductCategory,
                    meta: { requiresAuth: true }
                },
                {
                    name:'collectionProcessing',
                    path:'collectionProcessing',
                    component:CollectionProcessing,
                    meta: { requiresAuth: true }
                },
                {
                    name:'paymentProcessing',
                    path:'paymentProcessing',
                    component:PaymentProcessing,
                    meta: { requiresAuth: true }
                },
                {
                    name:'inventory',
                    path:'inventory',
                    component:Inventory,
                    meta: { requiresAuth: true }
                },
                {
                    name:'costReport',
                    path:'costReport',
                    component:CostReport,
                    meta: { requiresAuth: true }
                },
                {
                    name:'profitStatement',
                    path:'profitStatement',
                    component:ProfitStatement,
                    meta: { requiresAuth: true }
                },
                {
                    name:'receivableStatement',
                    path:'receivableStatement',
                    component:ReceivableStatement,
                    meta: { requiresAuth: true }
                },
                {
                    name:'paymentStatement',
                    path:'paymentStatement',
                    component:PaymentStatement,
                    meta: { requiresAuth: true }
                },
              ]
        },
    ]
});







// WEBPACK FOOTER //
// ./src/router/index.js